import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import {
  getAll as getProgramList,
  post as postProgram,
  patch as patchProgram,
  invalidateList as invalidateProgramList,
} from 'actions/programs';
import { GRADES } from 'constants/constants';
import { programTypeOptions } from 'constants/node';
import {
  NEW_PROGRAM_TYPE,
  NEW_PROGRAM_TYPE_OPTIONS,
  PROGRAM_STREAM_TYPE_OPTIONS,
  SUB_STREAM_TYPE_OPTIONS,
} from 'constants/program';

import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Dropdown,
  Button,
  Menu,
  Modal,
  Header,
  Form,
  Checkbox,
  TextArea,
  Divider,
} from 'semantic-ui-react';
import { Text, Row, Col, Separator } from '@cuemath/comps';
import { checkOrder } from 'utils';
import { JsonInput, MultipleTextInput } from 'comps';
import ChapterDropdown from './chapter-dropdown';
import NotificationPortal from 'comps/notification-portal';

const LongTextArea = styled(TextArea)`
  width: 600px;
  height: 40px;
`;

/*
Define dropdown with incoming values, default incoming value, plus '+' button for adding new entity given it's structure, default values, 'name' field and post request action.
On plus button, modal should be allowed to show with structure as sent to this component.
When the post request is complete, this dropdown's value should equal that of the new 'name' and 'key'.
*/

const GradeOptions = Object.keys(GRADES).map(grade => ({
  id: grade,
  text: grade,
  value: grade,
}));

const DEFAULT_BELT_CONFIG = {
  White: 0,
  Yellow: 0,
  Orange: 0,
  Green: 0,
  Purple: 0,
  Blue: 0,
  Brown: 0,
  Red: 0,
  Black: 0,
};

const DEFAULT_PROGRAM_DATA = {
  is_live: false,
  name: '',
  code: '',
  description: '',
  grade: '7',
  goal_enabled: false,
  belt_enabled: false,
  rewards_enabled: false,
  mobile_disabled: false,
  belt_config: DEFAULT_BELT_CONFIG,
  is_demo: false,
  grades: [],
  meta_data: { track_speed: false, total_classes: 80 },
};

const BeltOrder = [
  'White',
  'Yellow',
  'Orange',
  'Green',
  'Purple',
  'Blue',
  'Brown',
  'Red',
  'Black',
];

const ELECTIVE_META_CONFIG = [
  {
    key: 'users_enrolled',
    name: 'Total User Enrolled',
  },
  {
    key: 'image_url',
    name: 'Elective Image Url',
  },
  {
    key: 'video_url',
    name: 'Elective Video Url',
  },
  {
    key: 'duration',
    name: 'Program Duration (in hours)',
  },
];

class ProgramDropdown extends PureComponent {
  static propTypes = {
    programs: PropTypes.shape({}),
    actions: PropTypes.shape({}).isRequired,
  };

  constructor() {
    super();

    this.state = {
      programPostObj: store.post(),
      programPatchObj: store.patch(),
      modalOpen: false,
      programData: {},
      validationError: null,
    };
  }

  static getDerivedStateFromProps({ programs, actions }, prevState) {
    if (programs) {
      let newState = {};
      const programPost = store.post(programs, prevState.programPostObj.id);
      if (programPost.resolved && programPost.resolved.isCreated) {
        actions.invalidateProgramList();
        newState['programPostObj'] = programPost;
        newState['programData'] = programPost.resolved.data;
        newState['openSavedNotificationPortal'] = true;
        newState['notificationMessage'] = programPost.resolved.data.name + ' saved';
        newState['isNotificationError'] = false;
      } else if (programPost.resolved && programPost.resolved.isPatchingFailed) {
        const error = store.getError(programPost.resolved);
        newState['programPostObj'] = programPost;
        newState['openSavedNotificationPortal'] = true;
        newState['notificationMessage'] =
          '\n Program Not Created due to error: ' + JSON.stringify(error.message);
        newState['isNotificationError'] = true;
      }
      const programPatch = store.patch(programs, prevState.programPatchObj.id);
      if (programPatch.resolved && programPatch.resolved.isPatched) {
        actions.invalidateProgramList();
        newState['programPatchObj'] = programPatch;
        newState['programData'] = programPatch.resolved.data;
        newState['openSavedNotificationPortal'] = true;
        newState['notificationMessage'] = programPatch.resolved.data.name + ' saved';
        newState['isNotificationError'] = false;
      } else if (programPatch.resolved && programPatch.resolved.isPatchingFailed) {
        const error = store.getError(programPatch.resolved);
        newState['programPatchObj'] = programPatch;
        newState['openSavedNotificationPortal'] = true;
        newState['notificationMessage'] =
          '\n Program Not patched due to error: ' + JSON.stringify(error.message);
        newState['isNotificationError'] = true;
      }
      const programList = store.getAll(programs);
      if (programList && programList.data) {
        newState['programList'] = programList.data;
        if (programPost.resolved && programPost.resolved.isCreated) {
          newState['programList'].push(newState['programData']);
        }
      }
      return newState;
    }
    return null;
  }

  componentDidMount() {
    const { getProgramList } = this.props.actions;
    getProgramList();
  }

  changeDropdownContent = (event, { value }) => {
    const { setProgram } = this.props;
    const { programList } = this.state;
    const prgData = programList.find(prg => prg.id === value);
    setProgram(prgData);
    this.setState({
      programSelectedId: prgData.id,
    });
  };

  getProgramOptions() {
    const { programList } = this.state;
    if (!programList) {
      return [];
    }
    const programOptions = programList.map(program => ({
      key: program.id,
      value: program.id,
      text: program.code,
    }));
    return programOptions;
  }

  validateInput = () => {
    const re = /^(-1|[0-9\b]+)$/;
    const { programData } = this.state;
    const { grades, cue_program_type: cueProgramType, meta_data: metaData } = programData;

    if (
      !(re.test(programData.grade) && programData.grade >= -1 && programData.grade <= 12)
    ) {
      this.setState({
        openSavedNotificationPortal: true,
        isNotificationError: true,
        notificationMessage: 'Grade is not a number between 0 and 12',
      });
      return false;
    } else if (
      programData.belt_enabled &&
      !checkOrder(programData.belt_config, BeltOrder)
    ) {
      this.setState({
        openSavedNotificationPortal: true,
        isNotificationError: true,
        notificationMessage: 'Belt Config is not ordered properly',
      });
      return false;
    } else if (programData.description && programData.description.length > 80) {
      this.setState({
        openSavedNotificationPortal: true,
        isNotificationError: true,
        notificationMessage: 'Description should be less than 80 characters',
      });
      return false;
    }
    if (cueProgramType === NEW_PROGRAM_TYPE.ELECTIVES) {
      const mandatoryArrayFields = ['outcomes', 'sample_questions', 'topics_covered'];
      const emptyFields = [];
      if ((grades || []).length === 0) {
        emptyFields.push('grades');
      }
      mandatoryArrayFields.forEach(field => {
        if ((metaData[field] || []).length === 0) {
          emptyFields.push(field);
        }
      });
      if (emptyFields.length > 0) {
        this.setState({
          openSavedNotificationPortal: true,
          isNotificationError: true,
          notificationMessage: `${emptyFields.join(', ')} mandatory fields for Elective`,
        });
        return false;
      }
    }
    return true;
  };

  validateElectiveData = () => {
    const { programData } = this.state;
    const { meta_data: metaData } = programData;
    const mandatoryArrayFields = ['outcomes', 'sample_questions', 'topics_covered'];
    mandatoryArrayFields.forEach(field => {
      if ((metaData[field] || []).length > 0) {
        if (field === 'outcomes') {
          metaData[field] = metaData[field].filter(
            outcome => outcome.text && outcome.title,
          );
        } else {
          metaData[field] = metaData[field].filter(fieldVal => fieldVal);
        }
      }
    });
  };

  saveProgram() {
    const { postProgram, patchProgram } = this.props.actions;
    const { programData, programPostObj, isProgramNew, programPatchObj } = this.state;
    const { belt_enabled: beltEnabled, cue_program_type: cueProgramType } = programData;
    if (beltEnabled === false) {
      programData['belt_config'] = {};
    }

    if (programData && programData.total_classes) delete programData.total_classes;

    if (
      programData &&
      programData.meta_data &&
      (!programData.meta_data.total_classes ||
        !parseInt(programData.meta_data.total_classes))
    ) {
      programData.meta_data.total_classes = 80;
    }

    if (cueProgramType === NEW_PROGRAM_TYPE.ELECTIVES) {
      this.validateElectiveData();
    }
    if (isProgramNew) {
      postProgram(programPostObj.id, programData);
    } else {
      patchProgram(programPatchObj.id, programData.id, programData);
    }
  }

  handleChange = e => {
    let tempData = Object.assign({}, this.state.programData);
    if (e.target.name === 'grade') {
      tempData[e.target.name] = parseInt(e.target.value);
    } else {
      tempData[e.target.name] = e.target.value;
    }
    this.setState({
      programData: tempData,
    });
  };

  handleGradesDropdownChange = (e, { value }) => {
    const { programData } = this.state;
    const sortedGrades = value.sort((a, b) => +a - +b);
    this.setState({
      programData: { ...programData, grades: sortedGrades },
    });
  };

  handleChangeBeltConfig = e => {
    let tempData = Object.assign({}, this.state.programData);
    if (!tempData['belt_config']) {
      tempData['belt_config'] = DEFAULT_BELT_CONFIG;
    }
    tempData['belt_config'][e.target.name] = parseInt(e.target.value);
    this.setState({
      programData: tempData,
    });
  };

  handleChangeCheckbox = (e, { checked, name }) => {
    let tempData = Object.assign({}, this.state.programData);
    tempData[name] = checked;
    this.setState({
      programData: tempData,
    });
  };

  handleChangeDropdown = (event, { name, value }) => {
    const { programData } = this.state;
    const { [name]: _, ...result } = programData;
    this.setState({
      programData: { ...result, ...(value && { [name]: value }) },
    });
  };

  handleModalClose = () => {
    this.setState({
      modalOpen: false,
    });
  };

  newProgram = () => {
    this.openModal(DEFAULT_PROGRAM_DATA, true);
  };

  viewProgram = () => {
    const { selectedProgramData } = this.props;
    const { programList } = this.state;
    let prgData = programList.find(prg => prg.id === selectedProgramData.id);
    this.openModal(prgData, false);
  };

  openModal = (data, isNew) => {
    this.setState({
      modalOpen: true,
      isProgramNew: isNew,
      programData: data,
    });
  };

  handleCloseNotificationPortal = () => {
    this.setState({
      openSavedNotificationPortal: false,
      notificationMessage: '',
    });
  };

  handleSubmit = () => {
    if (this.validateInput()) {
      this.saveProgram();
      this.handleModalClose();
    } else {
    }
  };

  handleProgramMetaSubmit = (data, key) => {
    const { programData } = this.state;
    const { meta_data: metaData = {} } = programData;
    programData.meta_data = { ...metaData, [key]: data };

    this.setState({
      programData: { ...programData },
    });
  };

  renderExtraProgramField = () => {
    const { programData } = this.state;
    const { grades = [], meta_data: metaData = {} } = programData;
    const {
      is_only_chapter: isOnlyChapter,
      outcomes: programOutComes = [],
      topics_covered: topicCovered = [],
      sample_questions: sampleQuestions = [],
      detailed_description: detailedDiscription,
    } = metaData;

    return (
      <>
        <Divider />
        <Form.Field>
          <Row>
            <Col>
              <Text>Select Elective Grades</Text>
              <Dropdown
                label="select Grades (*)"
                width={20}
                placeholder="Select Grades"
                multiple
                selection
                value={grades}
                options={GradeOptions}
                onChange={this.handleGradesDropdownChange}
              />
            </Col>
            <Col>
              <Text>Single chapter elective ?</Text>
              <Separator transparent height="4" />
              <Checkbox
                name="is_only_chapter"
                label="yes"
                toggle
                checked={isOnlyChapter}
                onChange={(e, { name, checked }) => {
                  this.handleProgramMetaSubmit(checked, name);
                }}
              />
            </Col>
          </Row>
        </Form.Field>
        <Divider />
        <JsonInput
          label="Add program outcomes (*)"
          onSubmit={data => {
            this.handleProgramMetaSubmit(data, 'outcomes');
          }}
          inputKeys={['title', 'text']}
          inputData={programOutComes}
        />
        <Divider />
        <MultipleTextInput
          initialInput={topicCovered}
          label="Add topics covered (*)"
          onSubmit={data => {
            this.handleProgramMetaSubmit(data, 'topics_covered');
          }}
          inputType="TEXT"
        />
        <Divider />
        <MultipleTextInput
          initialInput={sampleQuestions}
          label="Add sample Questions (*)"
          onSubmit={data => {
            this.handleProgramMetaSubmit(data, 'sample_questions');
          }}
          inputType="TEXTAREA"
        />
        <Divider />
        <Row>
          <Col>
            <Text>Add elective program meta</Text>
          </Col>
        </Row>
        <Separator transparent height="6" />
        <Row>
          {ELECTIVE_META_CONFIG.map(config => (
            <Col key={config.key}>
              <Text>{config.name}</Text>
              <Form.Input
                name={config.key}
                value={metaData[config.key]}
                onChange={(e, { name, value }) =>
                  this.handleProgramMetaSubmit(value, name)
                }
              />
            </Col>
          ))}
        </Row>
        <Separator transparent height="10" />
        <Row>
          <Col>
            <Text>Detailed Description</Text>
            <LongTextArea
              name="detailed_description"
              label="Detailed description"
              value={detailedDiscription}
              onChange={(e, { name, value }) => this.handleProgramMetaSubmit(value, name)}
            />
          </Col>
        </Row>
        <Divider />
      </>
    );
  };

  render() {
    //Add Program
    const { setChapter, selectedProgramData, onNewChapter, setChapterCode } = this.props;

    const {
      modalOpen,
      openSavedNotificationPortal,
      notificationMessage,
      programSelectedId,
      isProgramNew,
      programData,
      isNotificationError,
    } = this.state;
    const { cue_program_type: cueProgramType, meta_data: metaData } = programData || {};

    const { total_classes: totalClasses, track_speed: trackSpeed } = metaData || {};

    return (
      <Fragment>
        <Modal
          id="program-create-modal"
          open={modalOpen}
          onClose={this.handleModalClose}
          size="large"
        >
          <Header icon="tasks" content="Create Program" />
          <Modal.Content style={{ pointerEvents: 'none' }}>
            {programData && (
              <Form onChange={this.handleChange}>
                <Form.Group>
                  <Form.Input
                    name="name"
                    label="Name"
                    width={5}
                    value={programData.name}
                  />
                  <Form.Input
                    name="code"
                    label="Code"
                    width={5}
                    value={programData.code}
                  />
                  <Form.Input
                    name="grade"
                    label="Grade"
                    width={5}
                    value={programData.grade}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    name="board"
                    label="Board"
                    width={5}
                    value={programData.board}
                  />
                  <Form.Select
                    name="program_type"
                    label="Program Type"
                    width={5}
                    compact
                    placeholder="Program Type"
                    value={programData.program_type}
                    options={programTypeOptions}
                    onChange={this.handleChangeDropdown}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    name="stream"
                    label="Program Stream"
                    compact
                    placeholder="Program Stream"
                    value={programData.stream}
                    options={PROGRAM_STREAM_TYPE_OPTIONS}
                    onChange={this.handleChangeDropdown}
                  />
                  <Form.Select
                    name="cue_program_type"
                    label="Cue Program Type"
                    compact
                    placeholder="Cue Program Type"
                    value={programData.cue_program_type}
                    options={NEW_PROGRAM_TYPE_OPTIONS}
                    onChange={this.handleChangeDropdown}
                  />
                  <Form.Select
                    name="sub_stream"
                    label="Program Sub-Stream"
                    compact
                    clearable
                    placeholder="Sub Program Stream"
                    value={programData.sub_stream}
                    options={SUB_STREAM_TYPE_OPTIONS}
                    onChange={this.handleChangeDropdown}
                  />

                  <Form.Input
                    name="total_classes"
                    label="Recommended No. of Classes"
                    width={3}
                    value={totalClasses}
                    onChange={(e, { name, value }) =>
                      this.handleProgramMetaSubmit(value, name)
                    }
                  />
                </Form.Group>
                <Form.Group>
                  <TextArea
                    name="description"
                    label="Description"
                    width={5}
                    placeholder="Program Description"
                    value={programData.description}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Field label="Is Live?" control="checkbox">
                    <Checkbox
                      name="is_live"
                      toggle
                      label="Yes"
                      checked={programData.is_live}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Goal Enabled?" control="checkbox">
                    <Checkbox
                      name="goal_enabled"
                      toggle
                      label="Yes"
                      checked={programData.goal_enabled}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Belt Enabled?" control="checkbox">
                    <Checkbox
                      name="belt_enabled"
                      toggle
                      label="Yes"
                      checked={programData.belt_enabled}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Rewards Enabled?" control="checkbox">
                    <Checkbox
                      name="rewards_enabled"
                      toggle
                      label="Yes"
                      checked={programData.rewards_enabled}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Mobile Disabled?" control="checkbox">
                    <Checkbox
                      name="mobile_disabled"
                      toggle
                      label="Yes"
                      checked={programData.mobile_disabled}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Chapter Locking?" control="checkbox">
                    <Checkbox
                      name="chapter_locking"
                      toggle
                      label="Yes"
                      checked={programData.chapter_locking}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="is demo?" control="checkbox">
                    <Checkbox
                      name="is_demo"
                      toggle
                      label="Yes"
                      checked={programData.is_demo}
                      onChange={this.handleChangeCheckbox}
                    />
                  </Form.Field>
                  <Form.Field label="Track Speed?" control="checkbox">
                    <Checkbox
                      name="track_speed"
                      toggle
                      label="Yes"
                      checked={trackSpeed}
                      onChange={(e, { name, checked }) =>
                        this.handleProgramMetaSubmit(checked, name)
                      }
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
            )}
            {programData && programData.belt_enabled && (
              <Form onChange={this.handleChangeBeltConfig}>
                <Form.Group>
                  <Form.Input
                    name="White"
                    label="White <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.White
                        ? programData.belt_config.White
                        : 0
                    }
                  />
                  <Form.Input
                    name="Yellow"
                    label="Yellow <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Yellow
                        ? programData.belt_config.Yellow
                        : 0
                    }
                  />
                  <Form.Input
                    name="Orange"
                    label="Orange <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Orange
                        ? programData.belt_config.Orange
                        : 0
                    }
                  />
                  <Form.Input
                    name="Green"
                    label="Green <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Green
                        ? programData.belt_config.Green
                        : 0
                    }
                  />
                  <Form.Input
                    name="Purple"
                    label="Purple <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Purple
                        ? programData.belt_config.Purple
                        : 0
                    }
                  />
                  <Form.Input
                    name="Blue"
                    label="Blue <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Blue
                        ? programData.belt_config.Blue
                        : 0
                    }
                  />
                  <Form.Input
                    name="Brown"
                    label="Brown <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Brown
                        ? programData.belt_config.Brown
                        : 0
                    }
                  />
                  <Form.Input
                    name="Red"
                    label="Red <"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Red
                        ? programData.belt_config.Red
                        : 0
                    }
                  />
                  <Form.Input
                    name="Black"
                    label="Black"
                    width={5}
                    value={
                      programData.belt_config && programData.belt_config.Black
                        ? programData.belt_config.Black
                        : 0
                    }
                  />
                </Form.Group>
              </Form>
            )}
            {cueProgramType === NEW_PROGRAM_TYPE.ELECTIVES &&
              this.renderExtraProgramField()}
          </Modal.Content>
        </Modal>
        <NotificationPortal
          openSavedNotificationPortal={openSavedNotificationPortal}
          notificationMessage={notificationMessage}
          handleCloseNotificationPortal={this.handleCloseNotificationPortal}
          isError={isNotificationError}
        />
        <Menu>
          <Menu.Item>
            <Dropdown
              width={20}
              placeholder="Select Program"
              search
              selection
              options={this.getProgramOptions()}
              onChange={this.changeDropdownContent}
            />
          </Menu.Item>
          <Menu.Item>
            <Button
              attached="right"
              icon="eye"
              onClick={this.viewProgram}
              disabled={!programSelectedId}
            />
          </Menu.Item>
        </Menu>

        <ChapterDropdown
          setChapterCode={setChapterCode}
          setChapter={setChapter}
          program={selectedProgramData}
          onNewChapter={onNewChapter}
        />
      </Fragment>
    );
  }
}

export default connect(
  ({ programs }) => ({
    programs: programs,
  }),
  dispatch => ({
    actions: bindActionCreators(
      { getProgramList, postProgram, patchProgram, invalidateProgramList },
      dispatch,
    ),
  }),
)(ProgramDropdown);
